export const chargeServicesDrawer = {
  title: "Frais et services",
  closeAria: "Fermer",
  subtitle: {
    catalog: "Catalogue réutilisable pour vos factures",
    select: "Sélectionnez les éléments à ajouter",
  },
  searchPlaceholder: "Rechercher un service…",
  createService: "Créer un service",
  loading: "Chargement des services…",
  empty: "Vous n'avez encore aucun service. Créez le premier.",
  item: {
    vat: "TVA {vat} %",
    edit: "Modifier",
    delete: "Supprimer",
  },
  footer: {
    selected: "{count} sélectionné | {count} sélectionnés",
    createInvoice: "Créer une facture avec ces éléments",
    addToInvoice: "Ajouter à la facture",
  },
  form: {
    editTitle: "Modifier le service",
    newTitle: "Nouveau service",
    subtitle: "Élément réutilisable pour vos factures",
    photoLabel: "Photo",
    optional: "optionnel",
    uploadPhoto: "Téléverser",
    nameLabel: "Nom",
    namePlaceholder: "ex. Ménage de fin de séjour",
    categoryLabel: "Catégorie",
    categoryPlaceholder: "ex. Ménage",
    priceLabel: "Prix",
    vatLabel: "TVA",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Détail affiché sur la facture",
    cancel: "Annuler",
    save: "Enregistrer les modifications",
    create: "Créer un service",
  },
  toasts: {
    loadError: "Impossible de charger les services.",
    photoError: "Impossible de téléverser la photo.",
    updated: "Service mis à jour.",
    created: "Service créé.",
    saveError: "Impossible d'enregistrer le service.",
    deleteError: "Impossible de le supprimer.",
  },
  confirmDelete: 'Supprimer "{name}" du catalogue ?',
};